import React, { useState } from 'react';

// Average property tax rates by county in New Jersey (per $100 of assessed value)
const NJ_PROPERTY_TAX_RATES = {
    'Atlantic': 2.42,
    'Bergen': 2.21,
    'Burlington': 2.53,
    'Camden': 3.08,
    'Cape May': 0.85,
    'Cumberland': 2.82,
    'Essex': 3.11,
    'Gloucester': 2.84,
    'Hudson': 2.10,
    'Hunterdon': 2.33,
    'Mercer': 2.69,
    'Middlesex': 2.36,
    'Monmouth': 2.09,
    'Morris': 2.24,
    'Ocean': 1.89,
    'Passaic': 2.90,
    'Salem': 2.71,
    'Somerset': 2.23,
    'Sussex': 2.48,
    'Union': 2.89,
    'Warren': 2.47,
};

function PropertyTaxCalculator() {
    const [propertyValue, setPropertyValue] = useState('');
    const [county, setCounty] = useState('Middlesex');
    const [result, setResult] = useState(null);

    const calculateTax = (e) => {
        e.preventDefault();
        const value = parseFloat(propertyValue);

        if (isNaN(value) || value <= 0) return;

        const rate = NJ_PROPERTY_TAX_RATES[county];
        const annualTax = (value * rate) / 100;
        const monthlyTax = annualTax / 12;

        setResult({
            propertyValue: value,
            county: county,
            rate: rate,
            annualTax: annualTax,
            monthlyTax: monthlyTax
        });
    };

    return (
        <div>
            <div className="calculator-header">
                <h3>Property Tax Estimator</h3>
                <p className="disclaimer">Estimates based on average county rates for 2024.</p>
            </div>

            <form onSubmit={calculateTax}>
                <div className="input-group">
                    <label>Property Value:</label>
                    <div className="input-with-icon">
                        <span className="currency-symbol">$</span>
                        <input
                            type="number"
                            step="10000"
                            value={propertyValue}
                            onChange={(e) => setPropertyValue(e.target.value)}
                            placeholder="0.00"
                        />
                    </div>
                </div>

                <div className="input-group">
                    <label>County:</label>
                    <select 
                        value={county} 
                        onChange={(e) => setCounty(e.target.value)}
                        className="select-input"
                    >
                        {Object.keys(NJ_PROPERTY_TAX_RATES).sort().map(countyName => (
                            <option key={countyName} value={countyName}>
                                {countyName} County
                            </option>
                        ))}
                    </select>
                </div>

                <button type="submit" className="calculate-btn">Calculate Property Tax</button>
            </form>

            {result && (
                <div className="results">
                    <div className="result-item">
                        <span className="result-label">Property Value:</span>
                        <span className="result-value">${result.propertyValue.toLocaleString()}</span>
                    </div>
                    <div className="result-item">
                        <span className="result-label">Tax Rate ({result.county} County):</span>
                        <span className="result-value">{result.rate}%</span>
                    </div>
                    <div className="result-item">
                        <span className="result-label">Annual Property Tax:</span>
                        <span className="result-value">${result.annualTax.toFixed(2)}</span>
                    </div>
                    <div className="result-item total">
                        <span className="result-label">Monthly Property Tax:</span>
                        <span className="result-value">${result.monthlyTax.toFixed(2)}</span>
                    </div>
                </div>
            )}
        </div>
    );
}

export default PropertyTaxCalculator;
